<!--  -->
<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">小程序名称</span>
        <el-input
          v-model="parameter.account_name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <div class="item">
        <span class="title">小程序app_id</span>
        <el-input
          v-model="parameter.app_id"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="account_name"
          label="小程序名称"
          align="center"
        />
        <el-table-column
          prop="app_id"
          label="小程序app_id"
          align="center"
        />

        <el-table-column
          prop="created_at"
          label="授权时间"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              @click="chooser(scope.row)"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import { miniprogramindex } from '@/api/hugeAdvertGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      parameter: {
        page: 1,
        page_size: 10,
        app_id: '',
        account_name: ''
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    send() {
      console.log('res')
      this.list()
    },
    async list() {
      const data = await miniprogramindex(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.list()
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        app_id: '',
        account_name: ''
      }
      this.list()
    },
    chooser(item) {
      console.log('item', item)
      this.$emit('callback', item)
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>
<style scoped lang="less">
.selectionArea {
  display: flex;
}

.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>
